import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_5,
  OPERATOR_TYPES_6,
} from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';
const filterTypes = [
  {
    attributeKey: 'name',
    attributeI18nKey: 'NAME',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_6,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'email',
    attributeI18nKey: 'EMAIL',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'phone_number',
    attributeI18nKey: 'PHONE_NUMBER',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'company_name',
    attributeI18nKey: 'COMPANY_NAME',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'additional_attributes',
  },
  {
    attributeKey: 'identifier',
    attributeI18nKey: 'IDENTIFIER',
    inputType: 'plain_text',
    dataType: 'number',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'labels',
    attributeI18nKey: 'LABELS',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_2,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'country_code',
    attributeI18nKey: 'COUNTRY',
    inputType: 'search_select',
    dataType: 'number',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'city',
    attributeI18nKey: 'CITY',
    inputType: 'plain_text',
    dataType: 'Number',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'created_at',
    attributeI18nKey: 'CREATED_AT',
    inputType: 'date',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_5,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'last_activity_at',
    attributeI18nKey: 'LAST_ACTIVITY',
    inputType: 'date',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_5,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'blocked',
    attributeI18nKey: 'BLOCKED',
    inputType: 'search_select',
    dataType: 'boolean',
    attribute_type: 'additional_attributes',
    filterOperators: OPERATOR_TYPES_1,
  },
  {
    attributeKey: 'referer',
    attributeI18nKey: 'REFERER_LINK',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_5,
    attributeModel: 'standard',
  },
];

export const filterAttributeGroups = [
  {
    name: 'Standard Filters',
    i18nGroup: 'STANDARD_FILTERS',
    attributes: [
      {
        key: 'name',
        i18nKey: 'NAME',
      },
      {
        key: 'email',
        i18nKey: 'EMAIL',
      },
      {
        key: 'phone_number',
        i18nKey: 'PHONE_NUMBER',
      },
      {
        key: 'company_name',
        i18nKey: 'COMPANY_NAME',
      },
      {
        key: 'identifier',
        i18nKey: 'IDENTIFIER',
      },
      {
        key: 'labels',
        i18nKey: 'LABELS',
      },
      {
        key: 'country_code',
        i18nKey: 'COUNTRY',
      },
      {
        key: 'city',
        i18nKey: 'CITY',
      },
      {
        key: 'created_at',
        i18nKey: 'CREATED_AT',
      },
      {
        key: 'last_activity_at',
        i18nKey: 'LAST_ACTIVITY',
      },
      {
        key: 'blocked',
        i18nKey: 'BLOCKED',
      },
    ],
  },
];

const COLUMN_FILTER_ATTRIBUTES = {
  name: { key: 'name', model: 'standard' },
  phone_number: { key: 'phone_number', model: 'standard' },
  company: { key: 'company_name', model: 'additional_attributes' },
  email: { key: 'email', model: 'standard' },
};

const PRESENCE_OPERATORS = { has: 'is_present', none: 'is_not_present' };

export const buildFilterItem = (
  key,
  operator,
  values = [],
  model = 'standard'
) => ({
  attribute_key: key,
  filter_operator: operator,
  values,
  query_operator: 'and',
  attribute_model: model,
});

export const buildColumnFilterItems = (columnFilters = {}) =>
  Object.entries(columnFilters).flatMap(([column, filter]) => {
    const attribute = COLUMN_FILTER_ATTRIBUTES[column];
    if (!attribute || !filter) return [];
    const items = [];
    const presenceOperator = PRESENCE_OPERATORS[filter.presence];
    if (presenceOperator) {
      items.push(
        buildFilterItem(attribute.key, presenceOperator, [], attribute.model)
      );
    }
    const term = (filter.value || '').trim();
    if (term) {
      items.push(
        buildFilterItem(attribute.key, 'contains', [term], attribute.model)
      );
    }
    return items;
  });

export const combineFilterItems = (baseItems = [], extraItems = []) => {
  const terms = [[]];
  baseItems.forEach((item, index) => {
    terms[terms.length - 1].push(item);
    if (index < baseItems.length - 1 && item.query_operator === 'or') {
      terms.push([]);
    }
  });
  return terms.flatMap((term, termIndex) => {
    const conditions = [...term, ...extraItems];
    const joiner = termIndex < terms.length - 1 ? 'or' : undefined;
    return conditions.map((condition, index) => ({
      ...condition,
      query_operator: index < conditions.length - 1 ? 'and' : joiner,
    }));
  });
};

export default filterTypes;
